function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-mediaService {\r\n                fill: currentColor;\r\n                stroke: currentColor;\r\n                stroke-width: .2px\r\n            }\r\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Component_267_1",
  "data-name": "Component 267 \\u2013 1",
  transform: "translate(.1 .1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4163",
  "data-name": "Group 4163",
  transform: "translate(2.854 1.587)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_8981",
  "data-name": "Path 8981",
  className: "cls-mediaService",
  d: "M197.333 166.251a.372.372 0 0 1-.318-.564l1.452-2.4a.372.372 0 0 1 .306-.179.368.368 0 0 1 .317.159l.832 1.193 1-1.046a.371.371 0 0 1 .51-.025l.808.694 1.243-3.174a.372.372 0 1 1 .692.271l-1.434 3.661a.371.371 0 0 1-.588.146l-.938-.805-1.073 1.119a.372.372 0 0 1-.573-.045l-.765-1.1-1.156 1.909a.372.372 0 0 1-.315.186z",
  transform: "translate(-196.962 -160.676)"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_8982",
  "data-name": "Path 8982",
  className: "cls-mediaService",
  d: "m205.659 201.17-2.427-1.857v-.855h-.743v.825l-2.467 1.887a.372.372 0 0 0 .452.59l2.016-1.543v1.259a.372.372 0 0 0 .372.371.372.372 0 0 0 .371-.372v-1.225l1.974 1.511a.372.372 0 0 0 .452-.59z",
  transform: "translate(-196.403 -188.849)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_8983",
  "data-name": "Path 8983",
  className: "cls-mediaService",
  d: "M195.979 153.2h-12.086a.372.372 0 1 0 0 .743h.291v6.56a1.491 1.491 0 0 0 1.487 1.487h8.545a1.491 1.491 0 0 0 1.487-1.487v-6.56h.278a.372.372 0 0 0 0-.743zm-1.021 7.3a.744.744 0 0 1-.743.743h-8.545a.744.744 0 0 1-.743-.743v-6.56h10.031z",
  transform: "translate(-183.521 -153.204)"
}));

function SvgMediaServices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.92,
    viewBox: "0 0 15 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaServices);
export default __webpack_public_path__ + "static/media/media-services.48d15207.svg";
export { ForwardRef as ReactComponent };